import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setNotification } from '../redux/slices/notificationSlice';

export function AuthRedirectHandler() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const handler = () => {

      navigate('/login', { replace: true });
      dispatch(
        setNotification({ severity: 'error', message: 'Session timed out. You have been logged out.' })
      );
    };
    window.addEventListener('authExpired', handler);
    return () => window.removeEventListener('authExpired', handler);
  }, [navigate]);
  return null;
}
